import {isString} from 'lodash';

export class StringHelper {
    static newLineToBrTag(str) {
        if (!isString(str)) {
            throw new Error('You should provide string');
        }

        return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    static decodeCyrillicFromUtf8(str) {
        return decodeURIComponent(str);
    }
}
